import request from './request'

export function search(data) {
    return request({
        url: '/api/case/list',
        method: 'get',
        params: data
    })
}